import { backgroundBlue, blue, blueDark, white } from '@/theme/colors'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const AdminContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	background-color: ${backgroundBlue};
`

export const AdminNav = styled.nav`
	display: flex;
	align-items: center;
	gap: 1.5rem;
	padding: 0 1.5rem;
	height: 56px;
	flex-shrink: 0;
	background-color: ${blueDark};
	color: ${white};

	@media (max-width: 600px) {
		padding: 0 0.875rem;
		gap: 1rem;
	}
`

export const AdminBrand = styled.span`
	font-weight: 700;
	font-size: 1.1rem;
	color: ${white};
	/* Small gap after the brand; nav links sit immediately to its right (left-aligned). */
	margin-right: 0.5rem;
`

export const AdminNavLink = styled(Link)<{ $active?: boolean }>`
	color: ${white};
	text-decoration: none;
	font-weight: ${({ $active }) => ($active ? 700 : 500)};
	opacity: ${({ $active }) => ($active ? 1 : 0.8)};
	border-bottom: 2px solid ${({ $active }) => ($active ? white : 'transparent')};
	padding: 2px 0;

	&:hover {
		opacity: 1;
	}
`

export const InternalToggle = styled.label`
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	color: ${white};
	font-size: 0.85rem;
	font-weight: 500;
	white-space: nowrap;
	cursor: pointer;
	user-select: none;
`

export const InternalCheckbox = styled.input`
	cursor: pointer;
	accent-color: ${white};
`

export const BackToAppLink = styled(Link)`
	color: ${white};
	text-decoration: none;
	font-weight: 500;
	opacity: 0.8;

	&:hover {
		opacity: 1;
	}
`

export const AdminContent = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 2rem 1.5rem;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const AdminHeading = styled.h1`
	margin: 0 0 1.5rem;
	font-size: 1.75rem;
	font-weight: 700;
	color: ${blue};
`
